import {generateAsyncActionCreators} from '../core/reduxUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';

const getTagProductsActionCreators = generateAsyncActionCreators(
  'GET_TAG_PRODUCTS',
  (params, cookies) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
  })
);

const getNextTagProductsActionCreators = generateAsyncActionCreators(
  'GET_NEXT_TAG_PRODUCTS',
  (params, cookies) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
  })
);

const getTagPageSeoActionCreators = generateAsyncActionCreators(
  'GET_TAG_PAGE_SEO',
  (params, cookies) => ({
    params: {
      ...params,
    },
    cookies,
  })
);

const actionCreators = {
  getTagProducts: {
    ...getTagProductsActionCreators,
  },

  getNextTagProducts: {
    ...getNextTagProductsActionCreators,
  },
  getTagPageSeo: {
    ...getTagPageSeoActionCreators,
  },
};

export {
  actionCreators,
  getTagProductsActionCreators,
  getNextTagProductsActionCreators,
  getTagPageSeoActionCreators,
};
